module.exports = __webpack_public_path__ + "media/images/heart-broken-ed8edbe0.svg";